var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, isNext, property_id } = options; 
__p+='\n';
 let omtagText = isNext ? "next_modal:listing" : "prev_modal:listing" 
__p+='\n<div class="listing-card-compact"\n  data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'">\n  <a href="javascript:void(0)"\n    class="bm-link-overlay" data-omtag="for_sale:ldp-quickview:'+
((__t=(omtagText))==null?'':__t)+
'" itemprop="url"></a>\n  <div class="aspect-content compact-card-image-wrapper">\n    <img src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="compact-card-image" alt="Property Photo">\n    <div class="overlay-text">\n      <div class="card-price">\n        '+
((__t=( property.price ))==null?'':__t)+
'\n      </div>\n      <div class="card-bed second-row">\n        '+
((__t=( property.beds ))==null?'':__t)+
' bed\n      </div>\n      <div class="card-bath second-row">\n        '+
((__t=( property.baths ))==null?'':__t)+
' bath\n      </div>\n    </div>\n    ';
 if (property_id == property.property_id) { 
__p+='\n      <div class="currently-viewing">\n        <span class="currently-viewing-text">Viewing</span>\n      </div>\n    ';
 } 
__p+='\n  </div>\n</div>\n ';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/qv-mini-srp-next-ten-props.jst.ejs